export {MessageRecipientItem as default};

/**
* Message Recipient Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageRecipientItem {
  /**
   * Full recipient
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String|undefined}
   */
  raw;

  /**
   * Recipient name
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String|undefined}
   */
  name;

  /**
   * Recipient email
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String|undefined}
   */
  email;
}